import React from 'react';
import classNames from 'classnames';
import { ErrorMessage, Field } from 'formik';

import useInputs from '../../../hooks/useInputs';
import { formStyles } from '../../../lib/constants/SiteVariables';

export default function StickyCheckbox(props) {
  const { id, label } = props;
  const { hasFieldError } = useInputs(props);

  return (
    <div className="relative flex flex-col items-start my-2 sm:my-3">
      <div className="flex items-start gap-3">
        <div className="flex mt-1">
          <Field
            id={id}
            name={id}
            aria-describedby="agree-checkbox"
            type="checkbox"
            className={classNames(
              'h-3 sm:h-4 w-3 sm:w-4 rounded border-tertiary-gray focus:ring-primary-blue mt-1 xs:mt-0',
              { 'border-error': hasFieldError },
            )}
          />
        </div>
        <div className="text-xs sm:text-sm leading-2">
          <label htmlFor={id}>
            {label}
          </label>
        </div>
      </div>
      <ErrorMessage
        name={id}
        component="div"
        className={classNames(
          'sm:h-5',
          formStyles.validation,
          hasFieldError ? 'my-0.5 h-4' : 'h-0',
        )}
      />
    </div>
  );
}

